import { api } from '@/config/api';

export type NoteEntityType = 'contact' | 'deal' | 'lead';

export interface NoteAttachment { url: string; name: string; mime: string; size: number; }

export interface Note {
  _id: string;
  noteUid: string;
  companyUid: string;
  entityType: NoteEntityType;
  entityUid: string;
  authorUserUid: string;
  body: string;
  mentions: string[];
  attachments: NoteAttachment[];
  editedAt?: string;
  createdAt: string;
}

const BASE = '/slighter_crm/notes';

export const notesService = {
  list: async (entityType: NoteEntityType, entityUid: string): Promise<Note[]> =>
    (await api.get(`${BASE}/${entityType}/${entityUid}`)).data,

  create: async (entityType: NoteEntityType, entityUid: string, body: string, attachments?: NoteAttachment[]): Promise<Note> =>
    (await api.post(`${BASE}/${entityType}/${entityUid}`, { body, attachments })).data,

  update: async (noteUid: string, body: string): Promise<Note> =>
    (await api.patch(`${BASE}/${noteUid}`, { body })).data,

  remove: async (noteUid: string): Promise<{ ok: boolean }> =>
    (await api.delete(`${BASE}/${noteUid}`)).data,
};
